import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import AsyncComputed from "vue-async-computed";
import vuetify from "./plugins/vuetify";
import { Http } from "./services";
import mixin from "./mixins/app";
import "./components/global";

Vue.config.productionTip = false;
Vue.prototype.$http = Http;
Vue.prototype.$globalStore = store;
Vue.use(AsyncComputed);
new Vue({
  router,
  vuetify,
  mixins: [mixin],
  render: (h) => h(App),
}).$mount("#app");
